import { Armchair, ArrowUpRight, ChefHat, DoorOpen, Warehouse, Wrench } from "lucide-react";
import { Card, CardContent } from "./ui/card";

const services = [
    {
        icon: ChefHat,
        title: "Kuchnie na wymiar",
        description: "Ergonomiczne układy, trwałe materiały, perfekcyjne wykończenie."
    },
    {
        icon: ArrowUpRight,
        title: "Schody na wymiar",
        description: "Nowoczesne i klasyczne konstrukcje dopasowane do wnętrza, trwałe materiały i precyzyjne wykonanie."
    },
    {
        icon: DoorOpen,
        title: "Drzwi wewnętrzne",
        description: "Stylowe i solidne drzwi dopasowane do aranżacji, komfort użytkowania i wysoka jakość wykończenia."
    },
    {
        icon: Warehouse,
        title: "Szafy i garderoby",
        description: "Maksymalne wykorzystanie przestrzeni i cichy domyk."
    },
    {
        icon: Armchair,
        title: "Salony i biura",
        description: "Nowoczesne zabudowy RTV, regały i biurka na miarę."
    },
    {
        icon: Wrench,
        title: "Montaż i serwis",
        description: "Pełna obsługa od pomiaru po montaż i wsparcie posprzedażowe."
    }
];

const ServicesSection = () => {
    return (
        <section id="oferta" className="section-padding bg-background">
            <div className="container mx-auto">
                <div className="text-center max-w-2xl mx-auto mb-16">
                    <span className="inline-block text-primary font-medium tracking-widest uppercase text-sm mb-4">
                        Oferta
                    </span>
                    <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
                        Co tworzymy
                    </h2>
                    <p className="text-muted-foreground text-lg">
                        Oferujemy szeroki zakres usług stolarskich. Każdy projekt realizujemy z dbałością o każdy detal.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {services.map((offer, index) => (
                        <Card
                            key={index}
                            className="group bg-card border-border/50 hover:border-primary/50 transition-all duration-300 hover-lift"
                        >
                            <CardContent className="p-8">
                                <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                                    <offer.icon className="h-7 w-7 text-primary" />
                                </div>
                                <h3 className="font-display text-xl font-semibold text-foreground mb-3">
                                    {offer.title}
                                </h3>
                                <p className="text-muted-foreground leading-relaxed">
                                    {offer.description}
                                </p>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ServicesSection;